'use strict';

const NombreUnidoFilter = (_, Util) => {
    'ngInject';

    return (objPersona) => {

        if (!_.isEmpty(objPersona)) {
          return Util.getNombreUnido(objPersona);
        }

        return objPersona;
    };
};

export default NombreUnidoFilter;



// WEBPACK FOOTER //
// ./src/app/common/core/filters/nombre-unido.filter.js